import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import merge from 'lodash/merge';
import styled from 'styled-components';

export const EmptyStateIcon = styled(FontAwesomeIcon).attrs(
  (props: FontAwesomeIconProps) =>
    merge({}, { size: '4x', color: 'var(--coolest-gray-70)' }, props),
)<FontAwesomeIconProps>``;
